import * as actionTypes from '../actions/actionTypes';

export default function caseMenuInfo(state = [], action) {
  switch (action.type) {
    case actionTypes.CASE_MENU:
      return action.caseMenuInfo ? action.caseMenuInfo : state
    case actionTypes.RESET_CASE_MENU:
      return {}
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/reducers/caseMenuInfo.js